export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20featuring%20layered%20overlapping%20translucent%20circular%20and%20rectangular%20shapes%20flowing%20diagonally%20across%20the%20canvas%20warm%20amber%20gold%20terracotta%20and%20cream%20tones%20blend%20seamlessly%20with%20soft%20diffused%20lighting%20creating%20depth%20and%20dimension%20minimalist%20architectural%20aesthetic%20clean%20sophisticated%20modern%20feel%20with%20subtle%20gradients%20and%20organic%20texture%20transitions%20no%20sharp%20edges%20serene%20balanced%20composition%20warm%20neutral%20palette&width=1600&height=900&seq=hero-bg-filoxenia&orientation=landscape"
          alt="Abstract geometric composition with warm tones"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="mb-8">
          <div className="w-16 h-px bg-primary-400 mx-auto mb-8"></div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 tracking-tight leading-tight">
            FILOXENIA.ONLINE P.C.
          </h1>
          <div className="w-16 h-px bg-accent-400 mx-auto mt-8"></div>
        </div>
        <p className="font-body text-lg md:text-xl text-background-200/90 max-w-2xl mx-auto leading-relaxed font-light">
          A professional engineering team dedicated to designing and developing modern digital software solutions for the iOS platform and related technologies
        </p>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-background-300/40 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-background-300/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}